import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {GlobalApp} from "../../../tools/global";
import {PreFilterInteractivesService} from "../../../api/services/pre-filter-interactives.service";
import {SubscriptionService} from "../../../api/services/subscription.service";
import {UserState} from "../../../api/models/user-state";
import {US_Interactive} from "../../../api/models/us_interactive";
import {UdPreFilteredInteractives} from "../../../api/models/ud-pre-filtered-interactives";
import {UdPreFilteredInteractiveFilters} from "../../../api/models/ud-pre-filtered-interactive-filters";
import {ShareState} from "../../../elements/share-editor/share-editor.component";
import {UserStateEx} from "../../../api/models-ex/user-state-ex";
import {US_SubHeader} from "../../../api/models/us_sub-header";
import {PreFilterKeysModel} from "../../../api/models/pre-filter-keys-model";
import {PreFilterFlatKeyValuesModel} from "../../../api/models/pre-filter-flat-key-values-model";
import {PreFilterHierarchyKeyValuesModel} from "../../../api/models/pre-filter-hierarchy-key-values-model";
import {MatLegacyOptionSelectionChange as MatOptionSelectionChange} from "@angular/material/legacy-core";

@Component({
  selector: 'app-edit-interactive-pre-filter',
  templateUrl: './edit-interactive-pre-filter.component.html',
  styleUrls: ['./edit-interactive-pre-filter.component.css']
})
export class EditInteractivePreFilterComponent implements OnInit {

  public isLoading: boolean = true;
  public isError: boolean = false;
  public errorMessage: string = '';

  private interactiveId: number = 0;
  private interactivePreFilterId: number = 0;

  public targetInteractive: US_Interactive;
  public preFilterInteractive: UdPreFilteredInteractives = {
    interactId: this.interactiveId,
    name: 'New Pre-Filtered Interactive',
    filters: [],
    subscriptionId: 0,
    preFilteredInteractiveId: 0,
    userId: 0,
    deleted: false
  }
  public preFilterValues: UdPreFilteredInteractiveFilters[] = [];
  public preFilterCuratedValues: CuratedFilterValue[] = [];
  public subscriptionHeaders: US_SubHeader[] = [];

  public preFilterKeys: PreFilterKeysModel[] = [];
  public shareState: ShareState;

  public initiallySelectedHierarchyValues: string[] = [];
  public currentlySelectedHierarchyValues: string[] = [];

  userState: UserState = {
    reportOnly: false,
    userManagerOnly: false,
    invoiceManagerOnly: false,
    interactives: [],
    modifiedInteractives: [],
    preFilteredInteractives: [],
    xmlas: [],
    reportExportState: {},
    isInteractiveUser: false,
    isReportExportUser: false,
    isEmbeddedUser: false
  };

  public selectedFilterKey: PreFilterKeysModel;
  public selectedFilterValue: PreFilterFlatKeyValuesModel;
  public selectedFilterValueText: string = '';

  public selectedFilterValues: PreFilterFlatKeyValuesModel[];
  public tmpSelectedFilterValues: PreFilterFlatKeyValuesModel[] = [];
  public filterValue: string = '';
  public filteredFlatValues: PreFilterFlatKeyValuesModel[] = [];

  constructor(
    private route: ActivatedRoute,
    private app: GlobalApp,
    private router: Router,
    private preFilterService: PreFilterInteractivesService,
    private subscriptionService: SubscriptionService,
  ) { }

  async ngOnInit(): Promise<void> {

    this.route.paramMap.subscribe(async params => {
      this.interactiveId = this.numberOrDefault(params.get("interactiveId"), 0);
      this.interactivePreFilterId = this.numberOrDefault(params.get("interactivePreFilterId"), 0);

      if(this.interactiveId !== 0)
      {
        this.userState = await this.subscriptionService.subscriptionGetUserSubscriptionState().toPromise();
        this.app.setUserState(this.userState);

        this.targetInteractive = this.userState.interactives.find(x => x.interactId == this.interactiveId);
        this.subscriptionHeaders = this.targetInteractive.subscriptionHeaders;

        if(this.targetInteractive.canPreFilter) {
          this.preFilterKeys = await this.preFilterService.preFilterInteractivesGetInteractivePreFilterKeys(this.interactiveId).toPromise();

          if(this.interactivePreFilterId !== 0) {
            this.preFilterInteractive = await this.preFilterService.preFilterInteractivesGetSubscriptionPreFilterInteractive(this.interactivePreFilterId).toPromise();
            this.preFilterValues = this.preFilterInteractive.filters;
            this.curateValues();
            this.shareState = UserStateEx.getPreFilteredInteractiveShareState(this.userState, this.userState.preFilteredInteractives.find(x => x.preFilteredInteractiveId === this.interactivePreFilterId));
          } else {
            this.preFilterInteractive = {
              interactId: this.interactiveId,
              name: 'New Pre-Filtered Interactive',
              filters: [],
              subscriptionId: 0,
              preFilteredInteractiveId: 0,
              userId: 0,
              deleted: false
            }
            this.preFilterValues = [];
            this.shareState = {
              subscriptionShareStates: []
            }
          }

          this.isLoading = false;
        } else {
          this.setError('Not eligible for pre-filtering.');
        }
      } else {
        this.setError('Invalid interactive');
      }
    })
  }

  curateValues(): void {
    this.preFilterCuratedValues = [];

    this.preFilterValues.forEach((value, index) => {
      const targetFilter = this.preFilterKeys.find(x => x.name === value.filterKey);
      if(targetFilter.keyType === 0 || targetFilter.keyType === 1) {
        const existingValue = this.preFilterCuratedValues.find(x => x.filterKey === value.filterKey);
        if (!existingValue) {
          this.preFilterCuratedValues.push({
            filterKey: value.filterKey,
            filterDax: value.filterDax,
            filterValue: '<Select Key Above To See Selections>',
            preFilteredInteractiveId: value.preFilteredInteractiveId,
            preFilteredInteractiveFilterId: value.preFilteredInteractiveFilterId,
            sourceIndexes: [index]
          });
        } else {
          existingValue.sourceIndexes.push(index);
        }
      } else {
        this.preFilterCuratedValues.push({
          ...value,
          sourceIndexes: [index]
        });
      }
    });
  }

  setError(errorMessage: string) {
    this.errorMessage = errorMessage;
    this.isError = true;
    this.isLoading = false;
  }

  numberOrDefault(strValue: string, defaultReturn: number): number {
    if(!isNaN(+strValue)) return +strValue;
    return defaultReturn;
  }

  addFilterKeyValue() {
    if (this.selectedFilterKey.keyType === 0) {
      const newSelectedValues = this.preFilterValues.filter(x => x.filterKey !== this.selectedFilterKey.name);
      this.selectedFilterValues.forEach(x => {
        newSelectedValues.push({
          filterKey: this.selectedFilterKey.name,
          filterDax: this.selectedFilterKey.daxName,
          filterValue: x.keyValue,
          preFilteredInteractiveFilterId: 0,
          preFilteredInteractiveId: 0
        });
      })
      this.preFilterValues = newSelectedValues;
    } else if (this.selectedFilterKey.keyType === 1) {
      const newSelectedValues = this.preFilterValues.filter(x => x.filterKey !== this.selectedFilterKey.name);
      this.currentlySelectedHierarchyValues.forEach(x => {
        newSelectedValues.push({
          filterKey: this.selectedFilterKey.name,
          filterDax: this.selectedFilterKey.daxName,
          filterValue: x,
          preFilteredInteractiveFilterId: 0,
          preFilteredInteractiveId: 0
        });
      })
      this.preFilterValues = newSelectedValues;
    } else {
      this.preFilterValues.push({
        filterKey: this.selectedFilterKey.name,
        filterDax: this.selectedFilterKey.daxName,
        filterValue: this.selectedFilterValueText,
        preFilteredInteractiveFilterId: 0,
        preFilteredInteractiveId: 0
      });
    }

    this.curateValues();
  }

  removeFilterValue(idx: number) {
    const selectedValue = this.preFilterCuratedValues[idx];
    const newValues : UdPreFilteredInteractiveFilters[] = [];
    this.preFilterValues.forEach((value, index) => {
      if (!selectedValue.sourceIndexes.includes(index)) {
        newValues.push(value);
      }
    })

    this.preFilterValues = newValues;
    this.curateValues();
  }

  savePreFilteredInteractive() {
    this.preFilterInteractive.filters = this.preFilterValues;
    if(this.interactivePreFilterId === 0) {
      this.preFilterService.preFilterInteractivesCreatePreFilterInteractive({
        preFilterInteractive: this.preFilterInteractive,
        subscriptionId: this.preFilterInteractive.subscriptionId
      }).subscribe(result => {
        if(result != null) {
          this.preFilterService.preFilterInteractivesUpdatePreFilterInteractiveSharing({
            preFilterInteractiveId: result.preFilteredInteractiveId,
            updateSharingStatus: UserStateEx.getSharingStatus(this.shareState)
          }).subscribe(result => {
            this.router.navigate(["interactives"]);
          })
        }
      });
    } else {
      this.preFilterService.preFilterInteractivesUpdatePreFilterInteractive({
        preFilterInteractive: this.preFilterInteractive,
        subscriptionId: this.preFilterInteractive.subscriptionId
      }).subscribe(result => {
        if(result != null) {
          this.preFilterService.preFilterInteractivesUpdatePreFilterInteractiveSharing({
            preFilterInteractiveId: result.preFilteredInteractiveId,
            updateSharingStatus: UserStateEx.getSharingStatus(this.shareState)
          }).subscribe(result => {
            this.router.navigate(["interactives"]);
          })
        }
      })
    }
  }

  hierarchySelectedValuesChanged(newValues: string[]) {
    this.currentlySelectedHierarchyValues = newValues;
  }

  selectedFilterKeyChanged() {
    if (this.selectedFilterKey.keyType === 1) {
      this.initiallySelectedHierarchyValues = this.preFilterValues.filter(x => x.filterKey === this.selectedFilterKey.name).map(x => x.filterValue);
    }
    else if(this.selectedFilterKey.keyType === 0) {
      this.filterValue = '';
      this.filteredFlatValues = this.selectedFilterKey.flatValues;
      this.selectedFilterValues = [];
      this.preFilterValues.filter(x => x.filterKey === this.selectedFilterKey.name).map(x => x.filterValue).forEach(x => {
        this.selectedFilterValues.push(this.selectedFilterKey.flatValues.find(y => y.keyValue === x))
      });


    }
    this.selectedFilterValue = undefined;
    this.selectedFilterValueText = '';
  }

  onFilterKeyEvent(value: string) {
    if (value === '') {
      this.selectedFilterValues = this.tmpSelectedFilterValues;
      this.tmpSelectedFilterValues = [];
    } else if (this.tmpSelectedFilterValues.length === 0) {
      this.tmpSelectedFilterValues = this.selectedFilterValues;
    }
    let filter = value.toLowerCase();
    this.filteredFlatValues = this.selectedFilterKey.flatValues.filter(x => x.keyValue.toLocaleLowerCase().startsWith(filter));
  }

  flatSelectionChange() {

  }

  flatInputChanged($event: MatOptionSelectionChange) {
    if (this.filteredFlatValues.length !== this.selectedFilterKey.flatValues.length) {
      if($event.source.selected) {
        this.tmpSelectedFilterValues.push($event.source.value);
      } else {
        const selectedIndex = this.tmpSelectedFilterValues.findIndex(x => x.keyValue === $event.source.value.keyValue);
        if(selectedIndex > -1) {
          this.tmpSelectedFilterValues.splice(selectedIndex, 1);
        }
      }
    }
  }
}

export interface CuratedFilterValue extends UdPreFilteredInteractiveFilters {
  sourceIndexes: number[];
}

export interface FilterableKey extends PreFilterKeysModel {
  filteredFlatValues?: Array<PreFilterFlatKeyValuesModel>;
  filteredHierarchyValues?: Array<PreFilterHierarchyKeyValuesModel>;
}
